import { render, staticRenderFns } from "./CampaignConfirmation.vue?vue&type=template&id=b3460f4c&scoped=true"
import script from "./CampaignConfirmation.vue?vue&type=script&lang=js"
export * from "./CampaignConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3460f4c",
  null
  
)

export default component.exports